function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useEffect, useState } from 'react';
import styles from './TabPanel.module.scss';
import { TabContext } from '../Tabs';
import uuid from '../../utils/uuid';
import cs from 'classnames';
import ThemeContext from '../../ThemeContext/ThemeContext';
export default function TabPanel(_ref) {
  var id = _ref.id,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    label = _ref.label,
    children = _ref.children;
  var _useState = useState(id || "tabpanel-".concat(uuid())),
    _useState2 = _slicedToArray(_useState, 1),
    tabId = _useState2[0];
  var context = useContext(TabContext);
  var theme = useContext(ThemeContext);
  var isSelected = context.selected === tabId;
  var dispatch = context.dispatch;
  useEffect(function () {
    dispatch({
      type: 'add:tab',
      payload: {
        id: tabId,
        i18n: label
      }
    });
  }, [dispatch, label, tabId]);
  useEffect(function () {
    if (selected) {
      dispatch({
        type: 'select:tab',
        payload: tabId
      });
    }
  }, [dispatch, selected, tabId]);
  return /*#__PURE__*/React.createElement("section", {
    id: tabId,
    role: "tabpanel",
    "aria-labelledby": "".concat(tabId, "-tab"),
    tabIndex: -1,
    className: cs(styles.panel, "_dm-tabpanel--".concat(theme), _defineProperty({}, styles.hidden, !isSelected))
  }, typeof children === 'function' ? children(isSelected) : children);
}